import { render, staticRenderFns } from "./space_source_match.vue?vue&type=template&id=7c6a76b0&scoped=true&"
import script from "./space_source_match.vue?vue&type=script&lang=js&"
export * from "./space_source_match.vue?vue&type=script&lang=js&"
import style0 from "./space_source_match.vue?vue&type=style&index=0&id=7c6a76b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6a76b0",
  null
  
)

export default component.exports